// Styles
import './AlternativeProduct.scss';

import cn from 'classnames';
import React from 'react';
import { NavLink } from 'react-router-dom';

import { ReactComponent as ArrowLSvg } from '@/common/assets/icons/arrow-L.svg';

import {
  contAlternativeProductDefaultProps,
  contAlternativeProductPropTypes,
} from './AlternativeProduct.proptypes';

const AlternativeProduct = ({ className, label, name, type, url }) => (
  <p
    className={cn(
      'alternative-product',
      type ? `alternative-product--${type}` : null,
      className,
    )}
  >
    <ArrowLSvg className="alternative-product__arrow" />
    {label}
    <NavLink className="alternative-product--link" to={url}>
      {name}
    </NavLink>
  </p>
);

AlternativeProduct.defaultProps = {
  ...contAlternativeProductDefaultProps,
};

AlternativeProduct.propTypes = {
  ...contAlternativeProductPropTypes,
};

export default AlternativeProduct;
